export default __webpack_public_path__ + "e050d64ecb5f5434d543ad0dfbc30dab.svg";